export const DAY_COLORS = [
  {
    hex: '#93C5FD', // blue-300
    bgClass: 'bg-blue-300',
    textClass: 'text-blue-600',
    borderClass: 'border-blue-300',
    lightBg: 'bg-blue-50',
  },
  {
    hex: '#86EFAC', // green-300
    bgClass: 'bg-green-300',
    textClass: 'text-green-600',
    borderClass: 'border-green-300',
    lightBg: 'bg-green-50',
  },
  {
    hex: '#C4B5FD', // purple-300
    bgClass: 'bg-purple-300',
    textClass: 'text-purple-600',
    borderClass: 'border-purple-300',
    lightBg: 'bg-purple-50',
  },
  {
    hex: '#FDBA74', // orange-300
    bgClass: 'bg-orange-300',
    textClass: 'text-orange-600',
    borderClass: 'border-orange-300',
    lightBg: 'bg-orange-50',
  },
  {
    hex: '#F9A8D4', // pink-300
    bgClass: 'bg-pink-300',
    textClass: 'text-pink-600',
    borderClass: 'border-pink-300',
    lightBg: 'bg-pink-50',
  },
  {
    hex: '#A5B4FC', // indigo-300
    bgClass: 'bg-indigo-300',
    textClass: 'text-indigo-600',
    borderClass: 'border-indigo-300',
    lightBg: 'bg-indigo-50',
  },
  {
    hex: '#FDE68A', // yellow-300
    bgClass: 'bg-yellow-300',
    textClass: 'text-yellow-600',
    borderClass: 'border-yellow-300',
    lightBg: 'bg-yellow-50',
  },
  {
    hex: '#FCA5A5', // red-300
    bgClass: 'bg-red-300',
    textClass: 'text-red-600',
    borderClass: 'border-red-300',
    lightBg: 'bg-red-50',
  },
] as const;

// Helper function to get day color by index
export const getDayColor = (dayIndex: number) => {
  return DAY_COLORS[dayIndex % DAY_COLORS.length];
};

// Export individual arrays for backward compatibility
export const DAY_COLOR_HEX = DAY_COLORS.map(color => color.hex);
export const DAY_COLOR_BG_CLASSES = DAY_COLORS.map(color => color.bgClass); 